import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api-client';
import { skillsResponseSchema, type Skill } from './schemas';

const MISSION_CONTROL_KEY = ['mission-control', 'all'] as const;

// Lê /api/mission-control.json e expõe apenas a lista de skills.
// Agents reusam o mesmo queryKey — uma fetch alimenta os dois caches.
export function useSkills() {
  return useQuery({
    queryKey: MISSION_CONTROL_KEY,
    queryFn: ({ signal }) =>
      api('/api/mission-control.json', { schema: skillsResponseSchema, signal }),
    select: (data): Skill[] => data.skillsList,
    staleTime: 60_000,
  });
}
